<template>
  <div v-if="visible" class="terms-overlay" @click.self="close">
    <div class="terms-dialog">
      <!-- colored card behind -->
      <div class="terms-dialog-bg"></div>
      <!-- main white card -->
             <div class="terms-dialog-inner">
         <div class="terms-header">
           <button class="terms-close" @click="close">&times;</button>
           <h2 class="terms-title">Terms and Conditions</h2>
         </div>
         
         <div class="terms-scrollable-content">
           <div class="terms-container">
             <div class="terms-content">
               <div class="terms-section">
                 <h3>Website Disclaimer</h3>
                 <p>This website is provided for general informational purposes only and should not be taken as legal advice. You use it at your own risk, and DMM Law accepts no responsibility or liability for damages arising from its use. If you require legal advice on any matter, please contact us.</p>
               </div>

               <div class="terms-section">
                 <h3>Copyright</h3>
                 <p>The content of this website is subject to copyright protection. Reproduction of the content, or any part of it, other than for educational purposes or personal use, is prohibited without prior consent from DMM Law.</p>
               </div>

               <div class="terms-section">
                 <h3>Terms of Use</h3>
                 <p><strong>Introduction.</strong> These terms and conditions (“the Terms and Conditions”) are binding on all persons that access the www.adams.africa or www.adamsadamsportal.com websites (“the Websites”) without qualification or exception. By entering the Websites, the person accessing the Websites (“the User”) agrees to be bound by and shall be deemed to have accepted these Terms and Conditions, which the User acknowledges to have read and understood. If the User does not agree to any of the Terms and Conditions, the User may not enter, view or make use of the Websites.</p>
                 <p><strong>1.1.</strong> DMM Law may from time to time amend these Terms and Conditions without notice to the User. The User’s continued use of these Websites shall constitute the User’s agreement to the amended Terms and Conditions.</p>
               </div>

               <div class="terms-section">
                 <h3>Website Use</h3>
                 <ul class="terms-list">
                   <li><strong>2.1.</strong> The User may not, without DMM Law’s written prior consent, use, reproduce, adapt, distribute, publish or in any other way deal or interfere with the Intellectual Property or the Websites’ contents.</li>
                   <li><strong>2.2.</strong> The User shall not infect the Websites with viruses, worms, trojan or any other code that has malicious, contaminating or destructive properties nor shall the User damage, interfere with or intercept any data or information contained on the Websites.</li>
                   <li><strong>2.3.</strong> Access to these Websites is made available for information purposes only. No content, information, statement or opinion on these Websites should be construed as legal advice. The User should consult an attorney if it seeks legal advice.</li>
                   <li><strong>2.4.</strong> DMM Law reserves the right to make any changes to the Websites and its content and/or services offered through the Websites at any time and without notice.</li>
                   <li><strong>2.5.</strong> The Websites may contain links to other websites. DMM Law has no control over such websites, does not review their content and will not be liable for their content or accuracy. The User accesses such websites at the User’s own risk and discretion.</li>
                   <li><strong>2.6.</strong> The User may not link to these Websites without DMM Law’s prior written consent.</li>
                   <li><strong>2.7.</strong> DMM Law makes no warranties, whether express or implied, in regard to the Websites, their contents, accuracy or availability. Without limiting the aforesaid, DMM Law does not warrant that the Websites or any files that may be downloaded from it are free of viruses, worms, trojan horses or any other code that has malicious, contaminating or destructive properties.</li>
                   <li><strong>2.8.</strong> The User assumes all responsibility and risk for the use of the Websites and communications from DMM Law. DMM Law shall not be liable for any loss, injury, damage, cost, penalty or claim resulting from the use of the Websites or communications received from DMM Law, whether direct or indirect, and whether or not DMM Law has been advised of or has knowledge of the possibility of such loss, injury, damage, cost, penalty or claim.</li>
                   <li><strong>2.9.</strong> The User hereby indemnifies DMM Law and holds it harmless against any and all liability, loss, damage, penalty, cost or claim of whatsoever nature suffered by any third party in relation to any act or omission by the User in relation to the Websites and communications received from DMM Law and the use thereof by the User, and/or arising from the provisions of these Terms and Conditions.</li>
                 </ul>
               </div>

               <div class="terms-section">
                 <h3>Website Privacy Policy</h3>
                 <p>Certain information regarding the User can be obtained automatically as the User navigates through the Websites. This includes, but is not necessarily limited to the User’s internet protocol address, internet browsing software and domain. This assists DMM Law to manage the Website and provide functionality.</p>
                 <p>DMM Law will use the user’s personal information for internal administrative, legal and client-service purposes and, where necessary for those purposes, may share your personal information with selected affiliated companies in which DMM Law or its ordinary shareholders hold an equity interest. Sharing will be limited to the minimum information required, for the specific purposes described, and only where appropriate safeguards are in place. The User has the right to withdraw consent at any time, to request access to, correction of, or deletion of personal information, and to ask for a list of the affiliated recipients and the purposes for which information was shared.</p>
                 <p><strong>3.1.</strong> The User may provide DMM Law with the User’s personal information. The User consents to DMM Law using such information for the purpose for which it is disclosed.</p>
                 <p><strong>3.2.</strong> The User consents to DMM Law sending to the User such newsletters and any other information or material which DMM Law deems may be of interest to the User.</p>
               </div>

               <div class="terms-section">
                 <h3>Membership</h3>
                 <p><strong>4.1.</strong> Your DMM Law membership will continue until terminated. To use DMM Law’s service you must provide one or more payment methods. “Payment Method” means a current, valid, accepted method of payment, as may be updated from time to time, and which may include payment through your account with a third party. Unless you cancel your membership before your billing date, you authorize us to charge the subscription fee for the next billing cycle to your Payment Method (see "Cancellation" below).</p>
                 <p><strong>4.2.</strong> We may offer a number of subscription plans, including subscriptions offered by third parties in conjunction with the provision of their own products and services. We are not responsible for the products and services provided by such third parties. Some subscription plans may have differing conditions and limitations, which will be disclosed at your sign-up or in other communications made available to you. You can find specific details regarding your DMM Law subscription by visiting the DMMLaw.co.za website and clicking on the "Membership" link available at the top of the pages.</p>
               </div>

               <div class="terms-section">
                 <h3>Membership Billing</h3>
                 <ul class="terms-list">
                   <li><strong>5.1. Billing Cycle.</strong> The subscription fee for DMM Law services and any other charges you may incur in connection with your use of the service, such as taxes and possible transaction fees, will be charged to your Payment Method on the 28th day of each month. The length of your billing cycle will depend on the type of subscription plan that you choose when you signed-up for the service. In some cases your payment date may change, for example if your Payment Method has not successfully settled, when you change your subscription plan or if your paid subscription began on a day not contained in a given month. We may authorize your Payment Method in anticipation of subscription or service-related charges through various methods, including authorizing it for up to approximately one month of service as soon as you register.</li>
                   <li><strong>5.2. Payment Methods.</strong> To use the DMM Law membership you must provide one or more Payment Methods. You authorize us to charge any Payment Method associated to your account in case your primary Payment Method is declined or no longer available to us for payment of your subscription fee. You remain responsible for any uncollected amounts. If a payment is not successfully settled, due to expiration, insufficient funds, or otherwise, and you do not cancel your account, we may suspend your access to the service until we have successfully charged a valid Payment Method. For some Payment Methods, the issuer may charge you certain fees, such as foreign transaction fees or other fees relating to the processing of your Payment Method. Local tax charges may vary depending on the Payment Method used. Check with your Payment Method service provider for details.</li>
                   <li><strong>5.3. Cancellation.</strong> You can cancel your DMM Law membership at any time, and you will continue to have access to DMM Law service through the end of your billing period. To the extent permitted by the applicable law, payments are non-refundable and we do not provide refunds or credits for any partial membership periods. To cancel, go to the "Account" page on the LiveLife App and follow the instructions for cancellation. If you cancel your membership, your account will automatically close at the end of your current billing period. On the "Account" page you can see when your account will close.</li>
                   <li><strong>5.4. Changes to the Price and Subscription Plans.</strong> We may change our subscription plans and the price of our service from time to time. We will notify you at least one month before any price changes or changes to your subscription plan will become effective. If you do not wish to accept the price change or change to your subscription plan, you can cancel your membership before the change takes effect.</li>
                 </ul>
               </div>

               <div class="terms-section">
                 <h3>Questions Service</h3>
                 <p>DMM Law offers a paid Questions Service by which a user may submit a legal question through the designated portal and, subject to payment and these Terms, receive a written answer from DMM Law within 72 hours of receipt of a valid submission and cleared payment.</p>
                 <ul class="terms-list">
                   <li><strong>6.1.</strong> The user must submit a valid submission that must include full and accurate contact details, a clear statement of the question or matter, any relevant documents, and any further information reasonably requested to enable DMM Law to answer. The Questions Service is intended for discrete legal queries and general advice only; it is not a substitute for ongoing legal representation, court appearances, or detailed transactional work.</li>
                   <li><strong>6.2.</strong> The service is activated only after the user submits a valid question, provides at least one accepted payment method, and payment is authorised or cleared in accordance with the payment method provided. Fees are non-refundable once DMM Law has commenced substantive work on the question, except where otherwise required by law or DMM Law’s refunds policy.</li>
                   <li><strong>6.3.</strong> Answers will be sent to the contact details provided by the user (email or in-platform message). If contact details are incorrect or incomplete, DMM Law is not liable for delayed or failed delivery. If additional information is required to answer the question, the 72 hour period pauses until DMM Law receives that information.</li>
                   <li><strong>6.4.</strong> A user who submits a question and receives a written answer is entitled to one complimentary 30-minute consultation to discuss the answer and related matters. The Free Consultation must be booked within 60 days of delivery of the written answer. Consultations are scheduled subject to DMM Law’s availability and may be conducted by telephone or video conference as specified at booking. The Free Consultation covers discussion of the original question and the written answer only, is limited to a single 30 minute session per submitted question and is non transferable and non refundable. Unused consultation time is forfeited. The user may cancel or reschedule the Free Consultation with at least 48 hours’ notice. DMM Law may cancel or reschedule for operational reasons with reasonable notice. If the user fails to attend a booked consultation without providing at least 24 hours’ notice, the Free Consultation will be deemed to have been used.</li>
                   <li><strong>6.5.</strong> Answers and the Free Consultation do not constitute a full legal opinion, comprehensive due diligence, or instructions to act. DMM Law may refuse, postpone, or escalate any question at its discretion, including where a conflict of interest exists, specialist advice beyond the Service scope is required, the matter involves criminal conduct, or a formal retainer is necessary. Where refused or escalated, DMM Law will notify the user and provide options for further engagement if applicable.</li>
                   <li><strong>6.6.</strong> Questions, supporting documents and consultation discussions are treated as confidential and processed in accordance with DMM Law’s Privacy Notice and POPIA obligations. By submitting a question the user consents to DMM Law processing their personal information for the purposes of providing the Questions Service and, where necessary, sharing limited information with affiliated entities as set out in the Privacy Notice. Users should not submit privileged or highly sensitive information unless requested, where such information is provided, users confirm they have the right to disclose it. Users retain their POPIA rights, including the right to withdraw consent, request access, correction or deletion, and to obtain details of any recipients and purposes of sharing.</li>
                   <li><strong>6.7.</strong> The user warrants that all information provided is true, accurate and not misleading, and that they have the right to disclose any documents submitted. The user agrees to promptly supply any further information DMM Law reasonably requests to enable completion of the answer and the Free Consultation within the stated timeframes.</li>
                   <li><strong>6.8.</strong> DMM Law’s liability in respect of the Questions Service and the Free Consultation is limited to the fee paid for the specific question. If, during or after the Free Consultation, the user requests further advice, formal opinions, representation, or other services, such work will require a separate engagement and may incur additional fees in accordance with DMM Law’s usual rates and billing terms. The firm may require a formal retainer for further work.</li>
                   <li><strong>6.9.</strong> The written answer provided under the Questions Service constitutes a legal opinion prepared by a legal advisor and should be treated as professional legal advice. It is issued for the specific person who submitted the question and for the limited purpose set out in the answer. Users must treat the answer as a legal opinion limited to the facts supplied and the scope stated. DMM Law accepts no responsibility for reliance on the answer where material facts were omitted, misstated, or where the user seeks to apply the answer to different facts, persons or jurisdictions. Receipt of an answer or participation in the Free Consultation does not create a solicitor client retainer for other matters; any further work or formal retainer will be subject to separate agreement and fees.</li>
                 </ul>
               </div>

               <div class="terms-section">
                 <h3>Refunds</h3>
                 <p>Refunds are available only where DMM Law has overcharged a User or the User has made a payment in excess of the amount specified for either the Questions Service or a monthly membership subscription. All other fees, including fees for services already performed outside those two categories, are non-refundable except where required by law.</p>
                 <ul class="terms-list">
                   <li><strong>7.1.</strong> A User must request a refund within seven (7) calendar days from the date the payment was made. Requests received after this seven day period will not be eligible except where otherwise required by law or where DMM Law agrees in its discretion. Valid refund requests for the Questions Service or a monthly membership subscription will be assessed and, if approved, processed within 14 business days of DMM Law receiving all required information. If DMM Law requires further verification, the processing period will be paused until the verification is complete.</li>
                   <li><strong>7.2.</strong> Refunds will be limited to the amount incorrectly charged or the amount paid in excess and do not include incidental costs or fees incurred by the User (such as third-party transaction fees). DMM Law may deduct any unrecoverable transaction fees actually charged to DMM Law by payment processors where permitted by law.</li>
                 </ul>
               </div>

               <div class="terms-section">
                 <h3>Cookies</h3>
                 <p>DMM Law’s websites make use of cookies. Cookies store information regarding website visitors. Cookies have various purposes, such as improving the visitor’s experience on the website and facilitating their use of the website. The website visitor may disable or decline cookies. However, if the visitor does so, their user experience on the site may be diminished.</p>
               </div>

               <div class="terms-section">
                 <h3>Governing Law</h3>
                 <p>The Terms and Conditions and the User’s use of the Websites shall be governed by and construed in accordance with the laws of the Republic of South Africa. The User irrevocably and unconditionally consents to the jurisdiction of the courts of the Republic of South Africa in regard to all matters arising from these Terms and Conditions or the User’s use of the Websites.</p>
               </div>

               <div class="terms-section">
                 <h3>Terms and Condition Agreement Changes</h3>
                 <p>DMM Law reserves the right to revise or substitute these provisions at any time at its sole discretion. Continued access to or use of the site following any revision constitutes your agreement to the revised terms.</p>
               </div>
             </div>
           </div>
         </div>

         <div class="terms-footer">
           <button class="terms-button" @click="close">
             I Agree
           </button>
         </div>
       </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TermsAndConditionsDialog",
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    close() {
      this.$emit("update:visible", false);
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.terms-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.terms-dialog {
  position: relative;
  width: 800px;
  max-width: 90vw;
  max-height: 80vh;
  min-height: 400px;
}

.terms-dialog-bg {
  position: absolute;
  top: 12px;
  left: 12px;
  width: 96%;
  height: 100%;
  border-radius: 16px;
  background-color: #002060;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15);
}

.terms-dialog-inner {
  position: relative;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15);
  max-height: 70vh;
  display: flex;
  flex-direction: column;
}

.terms-header {
  position: relative;
  padding: 32px 32px 20px 32px;
  text-align: center;
  border-bottom: 1px solid #e9ecef;
  background: #ffffff;
  border-radius: 16px 16px 0 0;
}

.terms-close {
  position: absolute;
  top: 16px;
  right: 16px;
  background: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
  line-height: 1;
  z-index: 10;
}

.terms-scrollable-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px 32px;
}

.terms-container {
  background-color: #f8f9fa;
  border-radius: 12px;
  padding: 24px;
  border: 1px solid #e9ecef;
}

.terms-title {
  font-size: 2em;
  margin: 0 0 20px 0;
  color: #002060;
}

.terms-content {
  text-align: left;
  margin-bottom: 32px;
}

.terms-section {
  margin-bottom: 20px;
}

.terms-section h3 {
  color: #002060;
  font-size: 1.2em;
  margin-bottom: 8px;
  font-weight: 600;
}

.terms-section p {
  font-size: 1em;
  line-height: 1.6;
  color: #333;
  margin: 0;
}
.terms-section + .terms-section {
  margin-top: 12px;
}

.terms-list {
  margin: 8px 0 0 18px;
  padding: 0;
  list-style: disc;
  color: #333;
  line-height: 1.6;
}
.terms-list li {
  margin-bottom: 10px;
}

.terms-footer {
  padding: 20px 32px 32px 32px;
  text-align: center;
  border-top: 1px solid #e9ecef;
  background: #ffffff;
  border-radius: 0 0 16px 16px;
}

.terms-button {
  border: none;
  border-radius: 8px;
  color: #ffffff;
  font-size: 1.1em;
  padding: 12px 24px;
  cursor: pointer;
  background-color: #002060;
}

.terms-button:hover {
  opacity: 0.9;
}

/* Scrollbar styling */
.terms-scrollable-content::-webkit-scrollbar {
  width: 8px;
}

.terms-scrollable-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.terms-scrollable-content::-webkit-scrollbar-thumb {
  background: #002060;
  border-radius: 4px;
}

.terms-scrollable-content::-webkit-scrollbar-thumb:hover {
  background: #001a4d;
}
</style>
